import apiClient from "../api";

/**
 * Service pour gérer les documents des représentants légaux et signataires
 */
export const legalRepresentativeDocumentService = {
  
  /**
   * Récupère tous les documents d'un représentant légal
   * @param {number} representativeId - ID du représentant légal
   * @returns {Promise<Array>} Liste des documents
   */
  async getLegalRepresentativeDocuments(representativeId) {
    try {
      const response = await apiClient.get(
        `/api/legalrepresentativedocuments/legal-representatives/${representativeId}/documents`
      );
      return response.data;
    } catch (error) {
      // console.error('Erreur lors de la récupération des documents du représentant:', error);
      throw new Error('Impossible de charger les documents du représentant légal');
    }
  },

  /**
   * Récupère tous les documents d'un signataire
   * @param {number} signatoryId - ID du signataire
   * @returns {Promise<Array>} Liste des documents
   */
  async getSignatoryDocuments(signatoryId) {
    try {
      const response = await apiClient.get(
        `/api/legalrepresentativedocuments/signatories/${signatoryId}/documents`
      );
      return response.data;
    } catch (error) {
      // console.error('Erreur lors de la récupération des documents du signataire:', error);
      throw new Error('Impossible de charger les documents du signataire');
    }
  },

  /**
   * Ouvre un document dans un nouvel onglet
   * @param {string} url - URL signée du document
   * @param {string} documentName - Nom du document pour le logging
   */
  async openDocument(url, documentName) {
    try {
      // Vérifier si l'URL est encore valide
      if (!url) {
        throw new Error('URL du document non disponible');
      }
      
      // Ouvrir le document dans un nouvel onglet
      window.open(url, '_blank', 'noopener,noreferrer');
      
      // console.log(`Document ouvert: ${documentName}`);
    } catch (error) {
      // console.error('Erreur lors de l\'ouverture du document:', error);
      throw new Error('Impossible d\'ouvrir le document');
    }
  },

  /**
   * Télécharge un document
   * @param {string} url - URL signée du document
   * @param {string} fileName - Nom du fichier pour le téléchargement
   */
  async downloadDocument(url, fileName) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Erreur lors du téléchargement');
      }
      
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName || 'document';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      // console.error('Erreur lors du téléchargement:', error);
      throw new Error('Impossible de télécharger le document');
    }
  }
};

export default legalRepresentativeDocumentService;